const SAFE_URL_RE = /^https?:\/\//i;

/**
 * Redirect to an external URL only if the protocol is http(s).
 * Rejects javascript:, data:, vbscript:, protocol-relative (//), and empty strings.
 */
export function safeExternalRedirect(
  url: string | undefined | null,
  fallback = "/",
): void {
  if (typeof url === "string" && SAFE_URL_RE.test(url)) {
    window.location.href = url;
    return;
  }
  console.warn("[safeExternalRedirect] blocked redirect to:", url);
  const safeFallback = typeof fallback === "string" && (fallback.startsWith("/") || SAFE_URL_RE.test(fallback))
    ? fallback
    : "/";
  window.location.href = safeFallback;
}
